import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  categoryApi,
  updateBrandApi,
  filtersApi,
  addFiltersApi,
  subCategoryApi,
  deleteCategoryApi,
} from "store/api";
import { Button, IconButton, TextField, Tooltip } from "@mui/material";
import { Add, DeleteRounded, EditRounded, Search } from "@mui/icons-material";

import Card from "@mui/material/Card";
import UpdateFilters from "../UpdateFilters";
import AddFilters from "../AddFilters";
import axios from "axios";
import Success from "components/Success";
import Stack from "@mui/material/Stack";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import { updateFiltersApi } from "store/api";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function FiltersTab () {
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [openAdd, setOpenAdd] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [category, setCategory] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [updateCategory, setUpdateCategory] = React.useState({
    name: "",
    isActive: "",
    subCategoryIds: [],
    options: [{ value: "", order: 1 }],
  });
  const [addCategoryImage, setAddCategoryImage] = React.useState({});
  const [updateCategoryImage, setUpdateCategoryImage] = React.useState({});
  const [addCategory, setAddCategory] = React.useState({
    name: "",
    isActive: "",
    subCategoryIds: [],
    options: [{ value: "", order: 1 }],
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleClickOpenUpdate = data => {
    setUpdateCategory(data);
    setOpenUpdate(true);
  };
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
    //   setOpen(true);
  };
  const handleCloseAdd = () => {
    setOpenAdd(false);
    //   setOpen(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [hoveredCategoryId, setHoveredCategoryId] = React.useState(null);
  const [subcategories, setSubcategories] = React.useState([]);
  const [expandedCategory, setExpandedCategory] = React.useState(null);
  const [loadingSub, setLoadingSub] = React.useState(false);

  const fetchSubcategories = async categoryId => {
    try {
      const res = await subCategoryApi({ categoryId: categoryId }); // Replace with your real API
      setSubcategories(res.data || []);
    } catch (err) {
      console.error("Failed to fetch subcategories", err);
      setSubcategories([]);
    }
  };

  const handleAccordionChange = categoryId => async (_, isExpanded) => {
    setExpandedCategory(isExpanded ? categoryId : null);

    if (isExpanded) {
      setLoadingSub(true);
      try {
        const res = await subCategoryApi({ categoryId: categoryId }); // Replace with your real API
        setSubcategories(res.data || []);
      } catch (err) {
        console.error("Error fetching subcategories", err);
        setSubcategories(prev => ({ ...prev, [categoryId]: [] }));
      }
      setLoadingSub(false);
    }
  };
  const handleOptionChange = (index, field, val) => {
    const updatedOptions = [...addCategory.options];
    updatedOptions[index][field] = val;
    setAddCategory({ ...addCategory, options: updatedOptions });
  };

  const addOptionRow = () => {
    setAddCategory(prev => ({
      ...prev,
      options: [...prev.options, { value: "", order: 1 }],
    }));
  };

  const removeOptionRow = index => {
    const updatedOptions = [...addCategory.options];
    updatedOptions.splice(index, 1);
    setAddCategory({ ...addCategory, options: updatedOptions });
  };

  const addUpdateOptionRow = () => {
    setUpdateCategory(prev => ({
      ...prev,
      options: [...prev.options, { value: "", order: 1 }],
    }));
  };
  const removeUpdateOptionRow = index => {
    const updatedOptions = [...updateCategory.options];
    updatedOptions.splice(index, 1);
    setAddCategory({ ...updateCategory, options: updatedOptions });
    setUpdateCategory({ ...updateCategory, options: updatedOptions });
  };
  const handleUpdateOptionChange = (index, field, val) => {
    const updatedOptions = [...updateCategory.options];
    updatedOptions[index][field] = val;
    setUpdateCategory({ ...updateCategory, options: updatedOptions });
  };
  const FetchFilter = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          searchKeyword: searchTerm,
        };
    try {
      const response = await filtersApi(params);
      if (response?.success) {
        setCategory(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const FetchCategory = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          searchKeyword: searchTerm,
        };
    try {
      const response = await categoryApi(params);
      if (response?.success) {
        setCategories(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);
  const handleChangeCategory = async e => {
    const { value } = e.target;
    // Clear the previous timeout
    if (debounceTimeout) clearTimeout(debounceTimeout);
    // Set a new timeout
    const newTimeout = setTimeout(() => {
      FetchFilter(value);
    }, 500); // Adjust debounce delay (500ms)

    setDebounceTimeout(newTimeout);
  };

  const handleSubmitUpdate = async e => {
    e?.preventDefault();
    let data = {
      ...updateCategory,
      options: updateCategory.options.map(opt => {
        const { filterOptionId, ...rest } = opt;
        return {
          ...rest,
          ...(filterOptionId && { optionId: filterOptionId }),
          operation: opt.filterId ? "edit" : "add",
          order: String(opt.optionOrder),
        };
      }),
    };
    const response = await updateFiltersApi(data);
    if (response?.success) {
      setMsg("Update Filter Successfully");
      setSuccess(true);
      FetchFilter();
      setOpenUpdate(false);
      setOpen(true);
    } else {
      setOpen(true);
      setOpenUpdate(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  const handleSubmitAdd = async e => {
    e?.preventDefault();
    const response = await addFiltersApi(addCategory);
    if (response?.success) {
      setMsg("Add Filter Successfully");
      setSuccess(true);
      FetchFilter();
      setOpenAdd(false);
      setOpen(true);
    } else {
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };

  const handleChangeUpdateCategory = e => {
    const { name, value } = e.target;
    setUpdateCategory(prev => {
      if (name === "subCategoryIds") {
        const existingIds = prev.subCategoryIds || [];
        const alreadyExists = existingIds.some(id => id.subCategoryId === value);

        const updatedIds = alreadyExists
          ? existingIds.filter(id => id.subCategoryId !== value) // remove if already exists
          : [...existingIds, { subCategoryId: value, order: 1, isActive: true }]; // add if not exists

        return {
          ...prev,
          [name]: updatedIds,
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };
  const handleChangeAddCategory = e => {
    const { name, value } = e.target;
    setAddCategory(prev => {
      if (name === "subCategoryIds") {
        const existingIds = prev.subCategoryIds || [];
        const alreadyExists = existingIds.some(id => id.subCategoryId === value);

        const updatedIds = alreadyExists
          ? existingIds.filter(id => id.subCategoryId !== value) // remove if already exists
          : [...existingIds, { subCategoryId: value, order: 1 }]; // add if not exists

        return {
          ...prev,
          [name]: updatedIds,
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };

  const DeleteCategory = async categoryId => {
    const params = {
      categoryId: categoryId,
    };
    const response = await deleteCategoryApi(params);
    if (response?.success) {
      setMsg("Delete Category Successfully");
      setSuccess(true);
      FetchFilter();
      setOpenAdd(false);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };
  const deleteFilterOption = async (filterData, index) => {
    if (filterData?.filterId) {
      let apiData = {
        filterId: filterData?.filterId,
        options: [
          {
            optionId: filterData.filterOptionId,
            operation: "delete",
          },
        ],
      };
      const response = await updateFiltersApi(apiData);
      if (response?.success) {
        setMsg("Option Delete From Filter Successfully");
        setSuccess(true);
        FetchFilter();
      } else {
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
      if (response?.response) {
        setSuccess(false);
        setMsg(response?.response?.data?.message);
      }
      setOpen(true);
    }else{
      removeUpdateOptionRow(index)
    }
  };

  React.useEffect(() => {
    FetchFilter();
    FetchCategory();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Filter</Typography>
        <Button
          variant='contained'
          startIcon={<Add />}
          color='success'
          onClick={() => handleClickOpenAdd()}
          //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
        >
          Add New Filter
        </Button>
      </div>

      {/* Search and Rows Per Page */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeCategory}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All Filter' {...a11yProps(0)} />
            <Tab label='Active Filter' {...a11yProps(1)} />
            <Tab label='Disable Filter' {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No filter found</div>}
            {category?.length > 0 &&
              category?.map(e => (
                <Category
                  category={e}
                  DeleteCategory={DeleteCategory}
                  handleClickOpenUpdate={handleClickOpenUpdate}
                />
              ))}
          </Grid2>
        </TabPanel>

        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No filter found</div>}
            {category?.length > 0 &&
              category?.map(
                e =>
                  e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No filter found</div>}
            {category?.length > 0 &&
              category?.map(
                e =>
                  !e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
      </Box>
      <UpdateFilters
        open={openUpdate}
        loadingSub={loadingSub}
        category={categories}
        addOptionRow={addUpdateOptionRow}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        subcategories={subcategories}
        removeOptionRow={removeUpdateOptionRow}
        deleteFilterOption={deleteFilterOption}
        expandedCategory={expandedCategory}
        updateCategoryData={updateCategory}
        handleOptionChange={handleUpdateOptionChange}
        handleAccordionChange={handleAccordionChange}
        handleChangeUpdateCategory={handleChangeUpdateCategory}
      />
      <AddFilters
        open={openAdd}
        loadingSub={loadingSub}
        category={categories}
        removeOptionRow={removeOptionRow}
        addOptionRow={addOptionRow}
        handleOptionChange={handleOptionChange}
        handleAccordionChange={handleAccordionChange}
        expandedCategory={expandedCategory}
        subcategories={subcategories}
        hoveredCategoryId={hoveredCategoryId}
        handleClose={handleCloseAdd}
        setHoveredCategoryId={setHoveredCategoryId}
        addCategoryData={addCategory}
        handleSubmit={handleSubmitAdd}
        handleChangeAddCategory={handleChangeAddCategory}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}

const Category = ({ category, DeleteCategory, handleClickOpenUpdate }) => {
  const navigate = useNavigate();
  return (
    <Grid2 xs={12} sm={6} md={3} style={{ border: "16px", overflow: "hidden" }}>
      <Card>
        <Stack spacing={2} sx={{ py: 1, px: 2 }}>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "500" }}
            noWrap
            // onClick={() => navigate(`/sub-category?id=${category.categoryId}`)}
          >
            <div style={{ fontSize: "20px" }}>{category?.name}</div>
            <div>
              Options
              {category?.options?.map((e, i) => (
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  {/* <div>{e.key}:</div> */}
                  <li>{e.value}</li>
                </div>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                fontSize: "0.875rem",
              }}
            >
              <div>Order: {category?.filterOrder}</div>
              <div>Active: {category.isActive ? "🟢" : "🔴"}</div>
            </div>
          </Box>
          <div
            title={"Edit"}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              position: "absolute",
              top: "-6px",
              right: "8px",
              fontSize: "16px",
            }}
            onClick={() => handleClickOpenUpdate(category)}
          >
            Edit
            <EditRounded style={{ fontSize: "16px", fill: "black" }} />
          </div>
        </Stack>
      </Card>
    </Grid2>
  );
};
